export function initReportsFilter() {
    const yearFilter = document.getElementById('yearFilter');
    const reportsContainer = document.getElementById('reportsContainer');

    if (!yearFilter || !reportsContainer) {
        return; // Not on a page with reports filter
    }

    // Initialize: show all reports on page load
    const reportWrappers = reportsContainer.querySelectorAll('[data-fiscal-year]');
    reportWrappers.forEach(wrapper => {
        wrapper.style.display = '';
    });

    yearFilter.addEventListener('change', function() {
        const selectedYear = this.value;
        
        // Filter reports by year
        filterReports(selectedYear);
    });

    function filterReports(year) {
        const reportWrappers = reportsContainer.querySelectorAll('[data-fiscal-year]');
        const yearHeaders = reportsContainer.querySelectorAll('[data-year-header]');
        let visibleCount = 0;
        const maxVisible = 5;
        let firstVisibleInYear = true;

        // Remove any existing "no reports" message
        const existingMessage = reportsContainer.querySelector('.no-reports-message');
        if (existingMessage) {
            existingMessage.remove();
        }

        // Fade out and slide down
        reportsContainer.style.opacity = '0';
        reportsContainer.style.transform = 'translateY(10px)';

        setTimeout(() => {
            // Handle year headers - show matching year header when filtering
            yearHeaders.forEach(header => {
                const headerYear = header.getAttribute('data-year-header');
                if (!year) {
                    // Show all year headers when "Latest" is selected
                    header.style.display = '';
                } else if (headerYear === year) {
                    // Show the matching year header when filtering
                    header.style.display = '';
                } else {
                    // Hide non-matching year headers
                    header.style.display = 'none';
                }
            });

            reportWrappers.forEach(wrapper => {
                const fiscalYear = wrapper.getAttribute('data-fiscal-year');
                let shouldShow = false;

                if (!year) {
                    // Show ALL reports when "Latest" is selected (no filter)
                    shouldShow = true;
                    // Use data-first-in-year attribute to determine highlight
                    const isFirstInYear = wrapper.getAttribute('data-first-in-year') === 'true';
                    if (isFirstInYear) {
                        wrapper.classList.add('c_report-highlight');
                    } else {
                        wrapper.classList.remove('c_report-highlight');
                    }
                } else {
                    // Filter by selected year (limit to 5)
                    shouldShow = fiscalYear === year && visibleCount < maxVisible;
                    
                    // Add highlight to first visible report when filtering by year
                    if (shouldShow && firstVisibleInYear) {
                        wrapper.classList.add('c_report-highlight');
                        firstVisibleInYear = false;
                    } else {
                        wrapper.classList.remove('c_report-highlight');
                    }
                }

                if (shouldShow) {
                    if (year) {
                        visibleCount++; // Only count when filtering by year
                    }
                    wrapper.style.display = '';
                } else {
                    wrapper.style.display = 'none';
                }
            });

            // Show "no reports" message if nothing is visible
            if (year && visibleCount === 0) {
                const dictionary = window.dictionary || { noReportsAvailableForYear: 'No reports available for' };
                const noReportsMsg = document.createElement('p');
                noReportsMsg.className = 'text-black/64 no-reports-message';
                noReportsMsg.textContent = `${dictionary.noReportsAvailableForYear} ${year}.`;
                reportsContainer.appendChild(noReportsMsg);
            }

            // Fade in and slide up
            reportsContainer.style.opacity = '1';
            reportsContainer.style.transform = 'translateY(0)';
        }, 150);
    }

    // Add fade and slide transition to container
    reportsContainer.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
}
